/**
 * templateLimits
 *
 * Centralized per-page limits and counts for templates, stock videos, etc.
 */

// Maximum number of template pages a basic user can see
export const BASIC_TEMPLATE_PAGE_LIMIT = 2;

// Page size for template pagination
export const TEMPLATES_PER_PAGE = 25;

// Number of stock videos to load per page
export const STOCK_VIDEOS_PER_PAGE = 10;

// Number of video templates to load per page
export const VIDEO_TEMPLATES_PER_PAGE = 10;

export default {
  BASIC_TEMPLATE_PAGE_LIMIT,
  TEMPLATES_PER_PAGE,
  STOCK_VIDEOS_PER_PAGE,
  VIDEO_TEMPLATES_PER_PAGE
}; 